import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { IHeaderParams } from 'ag-grid-community';
import { BaseGridHeader } from '../../tables/tabs/base-grid-header';

export interface AutomaticMeasureHeaderParams extends IHeaderParams {
  label: string;
  unit?: string;
}

@Component({
  selector: 'ces-automatic-measure-header',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './automatic-measure-header.component.html',
  styleUrl: './automatic-measure-header.component.scss',
})
export class AutomaticMeasureHeaderComponent extends BaseGridHeader<AutomaticMeasureHeaderParams> {
  label = '';
  unit = '';

  protected onInit(params: AutomaticMeasureHeaderParams): void {
    this.label = params.label;
    this.unit = params.unit ?? '';
  }
}
